import { useFormik } from "formik";
import {
  formikSetup,
  formikValidation,
  initialValues,
  validationSchema,
} from "../formikValidation";
import TextArea from "../../sharedComponents/textarea/textArea";
import {
  customStyle,
  styleEnd,
  styleStart,
} from "../../../algorithms/styleDirection";
import Button from "../../sharedComponents/buttons/button";
import { useEffect, useState } from "react";
import Lang from "../../../userPreferences/staticWords";
import DateInput from "../../sharedComponents/datesInputs/date";
import DropDownList from "../../sharedComponents/dropdown/dropdown";
import MembersList, { removeItem } from "../../../algorithms/listsAlogrithms";
import { resolver } from "../../../API/middlewares/resolveRequests";
import {
  editProjectForm,
  getCommunityProjectForm,
} from "../../../API/store/actions/projects/projects";
import { getDir } from "../../../algorithms/styleChanges";
import { englishDate } from "../../../algorithms";

const EditProjectForm = ({
  projectId,
  setVisible,
  communityId,
  data,
  setProjAdded,
  projAdded,
  userToken,
}) => {
  const saveHandler = async (values) => {
    let formData = new FormData();
    const newData = {
      NameA: values.Name,
      NameE: values.Name,
      DescriptionA: values.Description,
      DescriptionE: values.Description,
      StartDate: values.StartDate?.toString().includes("T0")
        ? values.StartDate
        : englishDate(values.StartDate) + "T00:00:00",
      EndDate: values.EndDate?.toString().includes("T0")
        ? values.EndDate
        : englishDate(values.EndDate) + "T00:00:00",
      PriorityId: parseInt(values.PriorityId),
      ProjectStatusId: parseInt(values.ProjectStatusId),
      ProjectTypeId: parseInt(values.ProjectTypeId),
      adminmemberIds: values.AdminMembers,
      memberIds: values.Members,
      Id: parseInt(projectId),
    };

    for (let [key, value] of Object.entries(newData)) {
      if (key == "adminmemberIds") {
        value.forEach((element) => {
          formData.append("adminmemberIds", element);
        });
      } else if (key == "memberIds") {
        value.forEach((element) => {
          formData.append("memberIds", element);
        });
      } else {
        formData.append(key, value);
      }
    }
    if (startDateError === false && endDateError === false) {
      if (values.AdminMembers.length > 0) {
        setAdminListError(false);
        let res = await editProjectForm(formData, communityId, userToken);
        if (res.status <= 206) {
          setVisible(false);
          setProjAdded(!projAdded);
        }
      } else {
        setAdminListError(true);
      }
    }
  };

  const [dropdowns, setDrobdowns] = useState({});

  useEffect(() => {
    resolver(getCommunityProjectForm, setDrobdowns, communityId, userToken);
  }, [communityId]);

  const [ProjectStatusDropdownList, setProjectStatusDropdownList] = useState(
    []
  );
  const [PriorityDropdownList, setPriorityDropdownList] = useState([]);
  const [ProjectTypeDropdownList, setProjectTypeDropdownList] = useState([]);
  const [AdminMembersList, setAdminMembersList] = useState([]);
  const [MemberList, setMemberList] = useState([]);

  useEffect(() => {
    if (dropdowns?.data?.members) {
      setAdminMembersList([
        ...dropdowns?.data?.members?.filter(
          (member) =>
            !values.Members.some(
              (projectmember) => projectmember == member.memberId
            )
        ),
      ]);
      setMemberList([
        ...dropdowns?.data?.members?.filter(
          (member) =>
            !values.AdminMembers.some(
              (adminmember) => adminmember == member.memberId
            )
        ),
      ]);
    }
    if (dropdowns?.data?.priorityLkp)
      setPriorityDropdownList(dropdowns?.data?.priorityLkp);
    if (dropdowns?.data?.projectStatusLkp)
      setProjectStatusDropdownList(dropdowns?.data?.projectStatusLkp);
    if (dropdowns?.data?.projectTypeLkp)
      setProjectTypeDropdownList(dropdowns?.data?.projectTypeLkp);
  }, [dropdowns]);

  const [StartDate, setStartDate] = useState(data?.StartDate);
  const [EndDate, setEndDate] = useState(data?.EndDate);
  const [startDateError, setStartDateError] = useState(false);
  const [endDateError, setEndDateError] = useState(false);
  const [adminListError, setAdminListError] = useState(false);

  const formik = useFormik(
    formikSetup(
      initialValues,
      data,
      validationSchema,
      "editProjectPopup",
      saveHandler
    )
  );
  const {
    errors,
    touched,
    handleSubmit,
    setFieldValue,
    values,
    setFieldTouched,
    handleChange,
  } = formik;
  return (
    <form onSubmit={handleSubmit}>
      <TextArea
        name={"Name"}
        containerStyle={"mb-4 col-12 align-items-center"}
        placeholder={Lang.title + "*"}
        rows="3"
        contentStyle={`scroll col-11 p-1`}
        onChange={handleChange}
        value={values?.Name ?? ""}
        errorMessage={formikValidation(touched, errors, "Name")}
      />

      <TextArea
        name={"Description"}
        containerStyle={"mb-4 col-12 align-items-center"}
        placeholder={Lang.Description}
        rows="3"
        contentStyle={`scroll col-11 p-1`}
        onChange={handleChange}
        value={values?.Description ?? ""}
        errorMessage={formikValidation(touched, errors, "Description")}
      />

      <div className="d-flex flex-xl-row justify-content-center col-12 flex-column mt-4">
        <div
          className={`d-flex flex-column align-items-center col-12 my-2 px-xl-5`}
        >
          <p className="mb-3 px-4 px-xl-2 col-12">{Lang.periodTime + "*"}</p>
          <div className="d-flex col-12 flex-xl-row flex-column align-items-center align-items-xl-start">
            <div
              className={`d-flex align-items-center align-items-xl-start flex-column col-11 col-xl-4 mb-xl-2 ${styleStart(
                "m",
                2
              )} ${styleStart("m", 0, "xl")}`}
            >
              <div className="col-12 align-items-center align-items-xl-start mb-xl-0 mb-3">
                <DateInput
                  errorMessage={
                    formikValidation(touched, errors, "StartDate") ||
                    startDateError === true
                      ? Lang.invalidDate
                      : null
                  }
                  style={{ padding: "21.5px" }}
                  placeholder={Lang.from}
                  containerStyle={"col-12"}
                  name={"StartDate"}
                  value={values?.StartDate}
                  onChange={(e) => {
                    setFieldValue("StartDate", e);
                    if (values.EndDate)
                      if (new Date(values.EndDate) >= new Date(e)) {
                        setEndDateError(false);
                        setStartDateError(false);
                      } else setStartDateError(true);
                  }}
                  iconPrefix="far"
                  iconName="calendar"
                  iconSize={22}
                />
              </div>
            </div>

            <div
              className={`d-flex flex-column align-items-center col-11 col-xl-4 mb-2 ${styleStart(
                "m",
                2
              )}`}
            >
              <div className="col-12 align-items-center">
                <DateInput
                  errorMessage={
                    formikValidation(touched, errors, "EndDate") ||
                    endDateError === true
                      ? Lang.invalidDate
                      : null
                  }
                  style={{ padding: "21.5px" }}
                  placeholder={Lang.to}
                  containerStyle={"col-12"}
                  value={values?.EndDate}
                  onChange={(e) => {
                    setFieldValue("EndDate", e);
                    if (values.StartDate)
                      if (new Date(values.StartDate) <= new Date(e)) {
                        setEndDateError(false);
                        setStartDateError(false);
                      } else setEndDateError(true);
                  }}
                  iconPrefix="far"
                  iconName="calendar"
                  iconSize={22}
                />
              </div>
              {/* {endDateError === true ? (
                    <div>
                      <p className="my-2 text-danger">{Lang.invalidDate}</p>
                    </div>
                  ) : null} */}
            </div>

            <DropDownList
              placeholder={Lang.priority + "*"}
              border={true}
              containerStyle={"col-xl-4 col-11 mb-3 my-xl-0 px-xl-2"}
              dataSource={PriorityDropdownList}
              value={values.PriorityId}
              change={(e) => {
                setFieldValue("PriorityId", e.value);
              }}
              errorMessage={formikValidation(touched, errors, "PriorityId")}
            />
          </div>
        </div>
      </div>

      <div className="d-flex flex-xl-row align-items-center col-12 flex-column mb-4">
        <DropDownList
          placeholder={Lang.projectStatus + "*"}
          border={true}
          containerStyle={`col-xl-6 col-11 mb-3 my-xl-0 ${styleStart(
            "p",
            5,
            "xl"
          )} ${styleEnd("p", 2, "xl")}`}
          dataSource={ProjectStatusDropdownList}
          value={values.ProjectStatusId}
          change={(e) => {
            setFieldValue("ProjectStatusId", e.value);
          }}
          errorMessage={formikValidation(touched, errors, "ProjectStatusId")}
        />

        <DropDownList
          placeholder={Lang.projectType + "*"}
          border={true}
          containerStyle={`col-xl-6 col-11 mb-3 my-xl-0 ${styleEnd(
            "p",
            5,
            "xl"
          )}`}
          dataSource={ProjectTypeDropdownList}
          value={values.ProjectTypeId}
          change={(e) => {
            setFieldValue("ProjectTypeId", e.value);
          }}
          errorMessage={formikValidation(touched, errors, "ProjectTypeId")}
        />
      </div>

      <MembersList
        onChangeSearch={(e) => {
          let searchKey = e.target.value; //HERE FILTER
          setAdminMembersList(
            [
              ...dropdowns?.data?.members.filter(
                (member) =>
                  ![...values.Members].some(
                    (admin) => admin.memberId == member.memberId
                  )
              ),
            ].filter((item) => item.memberName.includes(searchKey))
          );
        }}
        containerStyle="d-flex flex-column mx-xl-4 mx-3 my-4 col-12"
        aboveTitleStyle={`d-flex px-3 col-11 mb-3 ${styleStart("m", 2)}`}
        aboveTitle={Lang.addAdmainMembers + "*"}
        cardStyle={`d-flex flex-column col-11 px-3 py-2 mx-1 mx-lg-3 mx-xl-4 ${customStyle(
          "TitleCard"
        )}`}
        cardTitle={Lang.adminMembers}
        list={AdminMembersList}
        id={"A"}
        checked={true}
        values={values.AdminMembers}
        onChange={(e) => {
          if (e.target.checked) {
            setFieldValue("AdminMembers", [
              ...values.AdminMembers,
              parseInt(e.target.value),
            ]);
            setMemberList(
              MemberList.filter(
                (item) => parseInt(item.memberId) !== parseInt(e.target.value)
              )
            );
            setAdminListError(false);
          } else {
            setMemberList([
              AdminMembersList.find(
                (item) => parseInt(e.target.value) === parseInt(item.memberId)
              ),
              ...MemberList,
            ]);
            setFieldValue(
              "AdminMembers",
              removeItem(values.AdminMembers, parseInt(e.target.value))
            );
            if (values.AdminMembers.length > 0) {
              setAdminListError(false);
            } else {
              setAdminListError(true);
            }
          }
        }}
        listError={adminListError}
      />

      <MembersList
        onChangeSearch={(e) => {
          let searchKey = e.target.value; //HERE FILTER
          setMemberList(
            [
              ...dropdowns?.data?.members.filter(
                (member) =>
                  ![...values.AdminMembers].some(
                    (admin) => admin.memberId == member.memberId
                  )
              ),
            ].filter((item) => item.memberName.includes(searchKey))
          );
        }}
        containerStyle="d-flex flex-column mx-xl-4 mx-3 mb-5 col-12"
        aboveTitleStyle={`d-flex px-3 col-11 mb-3 ${styleStart("m", 2)}`}
        aboveTitle={Lang.addMembers}
        cardStyle={`d-flex flex-column col-11 px-3 py-2 mx-1 mx-lg-3 mx-xl-4 ${customStyle(
          "TitleCard"
        )}`}
        id={"B"}
        checked={true}
        values={values.Members}
        cardTitle={Lang.Members}
        list={MemberList}
        onChange={(e) => {
          if (e.target.checked) {
            setFieldValue("Members", [
              ...values.Members,
              parseInt(e.target.value),
            ]);
            setAdminMembersList([
              ...AdminMembersList.filter(
                (item) => parseInt(item.memberId) !== parseInt(e.target.value)
              ),
            ]);
          } else {
            setAdminMembersList([
              MemberList.find(
                (item) => parseInt(e.target.value) === parseInt(item.memberId)
              ),
              ...AdminMembersList,
            ]);
            setFieldValue(
              "Members",
              removeItem(values.Members, parseInt(e.target.value))
            );
          }
        }}
        listError={false}
      />

      <div className="d-flex flex-sm-row justify-content-center mt-5 mb-3 col-12">
        <Button
          content={Lang.save}
          containerStyle="col-3 mx-3"
          onClick={() => {
            if (values.AdminMembers.length > 0) setAdminListError(false);
            else setAdminListError(true);
          }}
          type={"submit"}
          buttonStyleType={"solid"}
        />

        <Button
          content={Lang.cancel}
          containerStyle="col-3 mx-3"
          onClick={() => {
            setAdminListError(false);
            setVisible(false);
          }}
        />
      </div>
    </form>
  );
};
export default EditProjectForm;
